import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { EmailVerificationForm } from "@features/EmailVerification/EmailVerificationForm";
import { EmailVerificationSuccess } from "@features/EmailVerification/EmailVerificationSuccess";
import { URLS } from "@constants";
import { fixUrlLanguage } from "@utils/changeLanguage";

export enum EmailVerificationStep {
    initial,
    success,
}

export const EmailVerificationPage = () => {
    const [step, setStep] = useState(EmailVerificationStep.initial);
    const { t } = useTranslation("forgotEmail");

    const isInitialStep = step === EmailVerificationStep.initial;
    const isSuccessStep = step === EmailVerificationStep.success;

    return (
        <div className="container-boxed login__container">
            <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                {isInitialStep && t("register")}
                {isSuccessStep && "Registration"}
            </Typography>
            <Card className="login__card" elevation={2}>
                <CardContent>
                    <Grid alignItems="center" container justify="center" spacing={2}>
                        {isInitialStep && (
                            <Fragment>
                                <Grid item>
                                    <div className="login__helper">
                                        <Typography align="center" color="secondary" variant="body1">
                                            {t("emailVerification")}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <EmailVerificationForm setStep={setStep} />
                                </Grid>
                            </Fragment>
                        )}
                        {isSuccessStep && (
                            <Grid item>
                                <EmailVerificationSuccess />
                            </Grid>
                        )}
                        <Grid className="login__links" item xs={12}>
                            <Link href={fixUrlLanguage(URLS.FORGOTEMAIL_PAGE_URL_EN)}>
                                <Typography align="center" color="primary">
                                    {t("forgotEmail")}
                                </Typography>
                            </Link>
                            <Link href={fixUrlLanguage(URLS.HOME_PAGE_URL_EN)}>
                                <Typography align="center" color="primary">
                                    {t("backLogin")}
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
